const networks = {
  /**
   * Configures a function that maps a network's publisher org to the network object.
   * @param {Object[]} organizations
   * @returns {function(Object[]): (boolean|Object[])}
   */
  mapPublisherTeamToNetwork(publishersAsTeams) {
    /**
     * Finds the network's publisher org, sets it on the network object, and returns the updated network object.
     * The `organization.billingCode` matches the `network.organization.code` property.
     * @param {Object[]} organizations
     * @returns {Object[]}
     */
    return (network) => {
      const { associationId, subId } = network || {}
      /**
       * Returns an unchanged network array if there is an error. Otherwise, returns false.
       * @returns {boolean|Object[]}
       */
      const error = () => {
        const hasOrganizationError = !associationId
        const hasTeamsError = !subId
        return (hasOrganizationError || hasTeamsError) && network
      }
      /**
       * Returns a network object with the publisher property set on it.
       * @returns {Object[]} networks
       */
      const success = () => {
        const foundTeam = publishersAsTeams.find((p) => p.billingCode === associationId && p.teamId === subId) || {
          billingCode: null,
          name: 'Team Unknown',
          publisherId: null,
        }

        return {
          associationId,
          publisher: foundTeam,
          subId,
        }
      }

      return error() || success()
    }
  },
}

export default networks
